import { useEffect, useReducer } from 'react';
import { ModalLayout, InputFormTable } from 'components';
import { Button, Input, Select } from 'antd';
import { SearchWordApi } from 'api';
import { useQueryClient } from '@tanstack/react-query';

import MessageAlert from 'utils';

const SearchWordModifyPopup = ({
  isOpen,
  setModifyPopupInfo,
  defaultData,
  searchWordList,
  onClose,
}) => {
  const queryClient = useQueryClient();
  const [state, dispatch] = useReducer(
    (state, action) => {
      switch (action.type) {
        case 'CHANGE_SEARCH_WORD':
          return {
            ...state,
            search_word: action.value,
          };
        case 'CHANGE_IS_SHOW':
          return {
            ...state,
            is_show: action.value,
          };
        case 'CLEAR':
          return {
            search_word_id: null,
            search_word: '',
            is_show: 'Y',
            order: searchWordList?.length + 1,
          };
        case 'INITIALIZE':
          return {
            ...action.value,
          };
        default:
          throw new Error(`${action.type}을 찾을 수 없습니다.`);
      }
    },
    {
      search_word_id: null,
      search_word: '',
      is_show: 'Y',
      order: searchWordList?.length + 1,
    }
  );

  const handleSave = async () => {
    if (!state.search_word) {
      MessageAlert.warning('추천 검색어를 입력해야 합니다.');
      return;
    }

    if (Array.isArray(searchWordList)) {
      const isAlreadyTagName = searchWordList.some(
        (searchWord) => searchWord.search_word === state.search_word
      );

      if (state.search_word_id === null && isAlreadyTagName) {
        MessageAlert.warning('이미 등록된 검색어입니다.');
        return;
      }
    }

    const response = await SearchWordApi.updateSearchWord({ ...state });

    if (response.status === 200) {
      const message =
        state.search_word_id === null
          ? '추천검색어를 등록하였습니다.'
          : '추천검색어를 수정하였습니다.';
      MessageAlert.success(message);
      setModifyPopupInfo({ isOpen: false, defaultData: null });
      setTimeout(() => {
        queryClient.resetQueries({ queryKey: ['searchWord'] });
        dispatch({ type: 'CLEAR' });
      }, 100);
    } else {
      MessageAlert.error('추천검색어 등록을 실패하였습니다.');
    }
  };

  useEffect(() => {
    if (defaultData) {
      const { search_word_id, search_word, is_show } = defaultData;
      dispatch({
        type: 'INITIALIZE',
        value: {
          search_word_id: search_word_id,
          search_word: search_word,
          is_show: is_show,
        },
      });
    }
  }, [defaultData]);

  return (
    <ModalLayout
      type="modal"
      open={isOpen}
      onCancel={onClose}
      centered
      closable
      title="추천검색어 수정"
      width={630}
      footer={
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Button onClick={handleSave}>수정</Button>
        </div>
      }
    >
      <div style={{ padding: '10px 0px' }}>
        <InputFormTable
          form={[
            {
              label: '추천검색어 명',
              required: true,
              form: [
                {
                  input: (
                    <Input
                      size="large"
                      placeholder="추천검색어 입력"
                      value={state.search_word}
                      onChange={(e) =>
                        dispatch({
                          type: 'CHANGE_SEARCH_WORD',
                          value: e.target.value,
                        })
                      }
                      showCount={true}
                      maxLength={20}
                    />
                  ),
                },
              ],
            },
            {
              label: '노출 여부',
              required: true,
              form: [
                {
                  input: (
                    <Select
                      size="large"
                      value={state.is_show}
                      options={[
                        { label: '노출', value: 'Y' },
                        { label: '노출안함', value: 'N' },
                      ]}
                      placeholder="노출여부를 선택하세요."
                      onChange={(value) => {
                        dispatch({ type: 'CHANGE_IS_SHOW', value: value });
                      }}
                    />
                  ),
                },
              ],
            },
          ]}
        />
      </div>
    </ModalLayout>
  );
};

export default SearchWordModifyPopup;
